import type { ActivityThread } from '@ayocore/activity/schemas/activity-thread.schema';
import type { ActivityFeedItem } from '@ayocore/activity/server/repositories/ActivityThreadRepository';

/**
 * Создаёт `ActivityFeedItem` из базового `ActivityThread` дополняя extras
 * безопасными дефолтами. Используется в embed-сценариях, когда мы получили
 * тред через `findByEntity` (он возвращает базовый ActivityThread) и хотим
 * сразу подставить его в `selectedThread`-state до того как `loadThreads`
 * принесёт полноценный FeedItem с агрегатами.
 *
 * После того как `loadThreads` завершится, `syncSelectedThreadFromThreads`
 * заменит этот объект на настоящий FeedItem из items (если найдётся).
 */
export function feedItemFromThread(thread: ActivityThread): ActivityFeedItem {
  return {
    ...thread,
    unread_count: 0,
    attention_unread_count: 0,
    my_overdue_count: 0,
    is_pinned: false,
    is_favorite: false,
    is_muted: false,
    is_archived: false,
    manual_rank: null,
    last_read_event_id: null,
    last_opened_at: null,
    last_event_payload: null,
    last_event_source: null,
    last_event_actor_user_id: null,
    last_event_created_at: null,
    last_event_comment_uuid: null,
    last_event_comment_content: null,
    // Аватар придёт с настоящим FeedItem из loadThreads — до этого fallback.
    entity_avatar_url: null,
    active_deals_total_count: 0,
    active_deals_preview_ids: [],
  };
}
